/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import { WeakRegistry } from '@blade/std-lib'
import { CurrencyAddress } from '@root/entities/currency'
import { currencyRegistry } from '@root/entities/currency/atoms'

import { premiumMetaUpdateReceived } from './premium-events'
import { reatomPremiumMeta, type PremiumMetaModel } from './reatom-premium-meta'

import type { CurrencyModel } from '@root/entities/currency'
import type { ServicesApi } from '@root/shared/api'

class PremiumMetaRegistry {
  private readonly registry = new WeakRegistry<
    CurrencyAddress,
    PremiumMetaModel
  >()

  public get = (currencyAddress: CurrencyAddress) => {
    return this.registry.get(currencyAddress)
  }

  public getOrCreate = (
    currencyAddress: CurrencyAddress,
    factory: () => PremiumMetaModel,
  ) => {
    const existing = this.get(currencyAddress)
    if (existing) {
      return existing
    }
    const model = factory()
    this.set(currencyAddress, model)
    return model
  }

  public set = (currencyAddress: CurrencyAddress, model: PremiumMetaModel) => {
    this.registry.set(currencyAddress, model)
  }

  public resolve = action(
    (
      ctx,
      {
        dto,
        currency,
      }: {
        dto: ServicesApi.PremiumMetaDto
        currency: CurrencyModel
      },
    ) => {
      return this.registry.getOrCreate(currency.address, () => {
        return reatomPremiumMeta({
          dto,
          currency,
        })
      })
    },
  )
}

export const premiumMetaRegistry = new PremiumMetaRegistry()

premiumMetaUpdateReceived.onCall((ctx, _, [{ currency, premiumMeta }]) => {
  const model = premiumMetaRegistry.get(CurrencyAddress(currency.address))

  if (model) {
    model.updateFromDto(ctx, premiumMeta)
    return
  }

  const meta = reatomPremiumMeta({
    dto: premiumMeta,
    currency: currencyRegistry.resolveFromTokenMeta(ctx, currency),
  })
  premiumMetaRegistry.set(CurrencyAddress(currency.address), meta)
})
